import {Comment} from '../../../../../integration/representation/contract';
import React from 'react';
import datafangstHelpers from '../../../../../utilities';
import {Checkbox, Glyphicon} from 'react-bootstrap';
import {connect} from 'react-redux';
import FeaturesState from '../../domain/FeaturesState';
import {markComment, onDeleteComments, setMarkedComments} from '../../../../actions/actions';
import {UserSession} from '../../domain';
import {contractId, markedComments, user} from '../../selectors';
import DeleteSingleCommentWithIcon from "./DeleteSingleCommentWithIcon";

interface SingleCommentTagProps {
    comment: Comment;
    commentResource: 'FEATURE_COMMENT' | 'FEATURE_TYPE_COMMENT';
}

interface SingleCommentStateProps {
    user: UserSession;
    contractId: string;
    checked: (id: string) => boolean;

}

interface SingleCommentDispatchProps {
    markComment: (id: string) => void;
    deleteComment: (id: string) => void;
    clearMarkedComments: () => void;
}

type SingleCommentProps = SingleCommentTagProps & SingleCommentDispatchProps & SingleCommentStateProps;

class SingleComment extends React.Component<SingleCommentProps, {}> {

    constructor(props: SingleCommentProps) {
        super(props);
        this.onConfirmDeleteComment = this.onConfirmDeleteComment.bind(this);
        this.onCommentMarkedCheckedChange = this.onCommentMarkedCheckedChange.bind(this);
    }

    onConfirmDeleteComment(){
        this.props.deleteComment(this.props.comment.id);
        this.props.clearMarkedComments();
    }

    onCommentMarkedCheckedChange(){
        this.props.markComment(this.props.comment.id);
    }

    render() {
        const {comment} = this.props;
        const canDeleteComment = this.props.user.hasPermission(this.props.commentResource + ':DELETE', this.props.contractId);
        return (
            <div className={"comment"}>
                <span className={"meta"}>
                    <span className="username">{comment.username}</span>
                    <time className={'color-mid-gray'}>{datafangstHelpers.formatDate(new Date(comment.createdInstant))}</time>
                    {!comment.error ? null :
                        <Glyphicon title="Markert som feil" glyph="fire" style={{color: 'red'}}/>}
                    {!(comment.username === this.props.user.username || canDeleteComment) ? null :
                        <span className={'remove-comment'}>
                            <DeleteSingleCommentWithIcon commentsToDelete={1} commentId={comment.id} onConfirm={this.onConfirmDeleteComment}/>
                            <Checkbox checked={this.props.checked(comment.id)} onChange={this.onCommentMarkedCheckedChange}/>
                        </span>
                    }
                </span>
                <pre className={"content"}>{comment.comment}</pre>
            </div>
        );
    }
}

const mapStateToProps = (state: FeaturesState): SingleCommentStateProps => ({
    user: user(state),
    contractId: contractId(state),
    checked: (id: string) =>  markedComments(state).indexOf(id) > -1
});
const mapDispatchToProps: SingleCommentDispatchProps = {
    markComment,
    clearMarkedComments: () => setMarkedComments([]),
    deleteComment: id => onDeleteComments([id])
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleComment);
